import React from 'react'
import AccountSettingSidebar from '../../../component/common/layout/AccountSettingSidebar'
import LeftSidebarNew from '../../../component/common/layout/LeftSidebarNew'
import SurveyListHeader from '../../../component/common/layout/SurveyListHeader'
import SurveyListSidebar from '../../../component/common/layout/SurveyListSidebar'
import Svg from '../../../component/common/Svg'
import Switch from '../../../core/Switch'
import { Link } from 'react-router-dom'
import NestedMenuToggle from './NestedMenuToggle'
import { useTranslation } from 'react-i18next';


export default function Notifications() {
      const { t, i18n } = useTranslation();

    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper main-site-wrapper bg-white'>
                <SurveyListHeader />
                <div id="viewport" className="d-flex bg-white">
                    <SurveyListSidebar />
                    <div className="flex-grow-1 d-flex">
                        <AccountSettingSidebar />
                        <div className="flex-grow-1 page-content-wrap">
                            <div className="page-heading">
                                {/* breadcrumbs here */}
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/admin/settings/profile">{t('settings.title')}</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/admin/settings/profile">{t('settings.general_breadcrumb')}</Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            <strong>Notifications</strong>
                                        </li>
                                    </ol>
                                </nav>
                                {/* breadcrumbs ends here */}
                                <div className="d-flex align-items-start">
                                    <NestedMenuToggle />
                                    <div className="flex-grow-1">
                                        <h1>Notifications Settings</h1>
                                    </div>
                                </div>
                                
                            </div>
                            <div className="profile-wrapper">
                                <div className="main-form-wrapper notification-setting">

                                    <div className="field-wrapper d-flex justify-content-between align-items-center">
                                        <div className="small-heading">
                                            <h6 className='mb-0'>Default</h6>
                                        </div>
                                        <div className="switch-wrap">
                                            < Switch
                                                type='def'
                                                color='default'
                                                checked={true}
                                                disabled={false}
                                                fill={false}
                                                rtl={false}
                                                leftPosition={false}
                                                className='SwitchCustom'
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
